import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

const PageSizeSelect = ({
  pageSizeOptions,
  onPageSizeChange,
  defaultPageSize,
}: any) => {
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageSizeMenuOpen, setPageSizeByMenuOpen] = useState(false);

  const handleActiveElement = (elem: any) => {
    setPageSize(elem);
    setPageSizeByMenuOpen(false);
    onPageSizeChange(elem.key);
  };

  return (
    <div className="flex /w-full h-full justify-start lg:justify-end">
      <DropdownMenu modal={false} open={pageSizeMenuOpen}>
        <DropdownMenuTrigger
          onClick={() => setPageSizeByMenuOpen(!pageSizeMenuOpen)}
          asChild
        >
          <div className="relative hover:bg-primary/90 bg-primary rounded-md cursor-pointer h-10 flex items-center justify-between px-2">
            <span className="flex h-full items-center gap-2 text-white">
              {pageSize.label}
            </span>

            <ChevronDown className="h-4 w-4 ms-2 mt-1" />
          </div>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="mt-1 w-[60px] min-w-0 flex flex-col gap-y-1 border-none bg-black drop-shadow-2xl py-2 text-white">
          {pageSizeOptions.map((elem: any) => {
            return (
              <div
                key={elem?.key + elem?.dir}
                onClick={() => {
                  handleActiveElement(elem);
                }}
                className={`flex h-fit justify-center gap-10 rounded-none px-2 py-2 focus:border-none hover:cursor-pointer hover:bg-primary ${
                  pageSize.key === elem?.key ? "bg-primary" : ""
                }`}
              >
                <div className="group flex items-center gap-2">
                  <p
                    className={`text-sm 
                   ${pageSize.key === elem?.key ? "text-white" : "text-white"}`}
                  >
                    {elem?.label}
                  </p>
                </div>
              </div>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default PageSizeSelect;
